(function (w, d) {
	const lists = d.querySelectorAll('.js-dropdown-list');
	const throttleTime = 200;
	const isMobile = () => w.innerWidth < 960;

	w.addEventListener('resize', throttle(isMobile, throttleTime));

	if (isMobile && lists) {
		d.addEventListener('click', event => {
			const targetElement = event.target;

			lists.forEach(list => {
				if (list.dataset.navIndex === targetElement.dataset.navIndex && targetElement !== list) {
					event.preventDefault();
					list.classList.toggle('nav__sublist_active');
				}
			})
		});
	}
})(window, document);
